<template>
  <b-form-group role="group">
    <label><slot name="label"></slot></label>
    <b-input-group :prepend="prepend" :append="append">
      <select2
        :disabled="disabled"
        :class="inputClasses"
        :taggable="taggable" :multiple="multiple"
        :options="options"
        v-model="select2Value"
        :placeholder="placeholder">
        <option disabled>{{placeholder}}</option>
      </select2>
      <b-input-group-append>
        <slot name="append"></slot>
      </b-input-group-append>
    </b-input-group>
    <b-form-invalid-feedback :force-show="showValidationMessage">
      {{validationMessage}}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    'value': {
      type: [String, Number, Array],
      default: ''
    },
    'inputClasses': {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    },
    'placeholder': [String, Number],
    'name': String,
    'required': Boolean,
    'v': Object,
    'prepend': {
      type: [String],
      default: ''
    },
    'append': {
      type: [String],
      default: ''
    }
  },
  data () {
    return {
      select2Value: null
    }
  },
  watch: {
    value (newVal, oldVal) {
      if (this.options.length && newVal !== oldVal) {
        if (Array.isArray(this.value)) {
          this.select2Value = newVal
        } else {
          let option = this.getOptionsByValue(this.value)
          this.select2Value = option
        }
      }
    },
    select2Value (newVal) {
      if (Array.isArray(this.value)) {
        this.updateInput(newVal || [])
      } else {
        this.updateInput((newVal && newVal.value) ? newVal.value : newVal)
      }
      this.emitBlur()
    },
    options (newVal) {
      if (newVal && newVal.length) {
        let val = this.options.find(
          (option) => {
            return option.value === this.value
          }
        )
        this.select2Value = val
      }
    }
  },
  computed: {
    showValidationMessage () {
      if (!this.v) {
        return false
      } else {
        return (!this.v.$dirty) ? false : (this.v.$dirty && this.v.$invalid)
      }
    },
    validationMessage () {
      let str = ''

      if (this.v) {
        if (!this.v.required) {
          str = 'This field is required'
        }
      }

      return str
    }
  },
  methods: {
    updateInput (value) {
      this.$emit('input', value)
    },
    emitBlur () {
      this.$emit('blur')
    },
    setFocus () {
      this.$el.querySelector('input').focus()
    },
    getOptionsByValue (value) {
      return this.options.find(
        (option) => {
          return option.value === value
        }
      )
    }
  }
}
</script>

<style>
  /*.v-select .dropdown-toggle {*/
    /*border-radius: 0px !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/Common/selectFields.vue